import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <g clipPath='url(#Icon_chrome_svg__a)'>
      <path
        fill='url(#Icon_chrome_svg__b)'
        d='M37.7 21.084h28.413a32.803 32.803 0 0 0-56.826.003l14.206 24.606.013-.003A16.387 16.387 0 0 1 37.7 21.084'
      />
      <path
        fill='url(#Icon_chrome_svg__c)'
        d='M51.916 45.69 37.71 70.297a32.804 32.804 0 0 0 28.41-49.214H37.708l-.003.012a16.386 16.386 0 0 1 14.211 24.597'
      />
      <path
        fill='url(#Icon_chrome_svg__d)'
        d='M23.498 45.698 9.292 21.093a32.804 32.804 0 0 0 28.417 49.21l14.205-24.605-.009-.01a16.386 16.386 0 0 1-28.407.01'
      />
      <path
        fill='#fff'
        d='M37.705 53.898c9.061 0 16.406-7.346 16.406-16.407s-7.345-16.406-16.406-16.406S21.3 28.43 21.3 37.491s7.345 16.407 16.406 16.407'
      />
      <path
        fill='#1A73E8'
        d='M37.705 50.48c7.173 0 12.988-5.816 12.988-12.989s-5.815-12.988-12.988-12.988-12.988 5.815-12.988 12.988S30.532 50.48 37.705 50.48'
      />
    </g>
    <defs>
      <linearGradient
        id='Icon_chrome_svg__b'
        x1={62.568}
        x2={34.155}
        y1={19.036}
        y2={68.249}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D93025' />
        <stop offset={1} stopColor='#EA4335' />
      </linearGradient>
      <linearGradient
        id='Icon_chrome_svg__c'
        x1={67.983}
        x2={11.157}
        y1={25.185}
        y2={25.185}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCC934' />
        <stop offset={1} stopColor='#FBBC04' />
      </linearGradient>
      <linearGradient
        id='Icon_chrome_svg__d'
        x1={41.257}
        x2={12.844}
        y1={68.255}
        y2={19.042}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1E8E3E' />
        <stop offset={1} stopColor='#34A853' />
      </linearGradient>
      <clipPath id='Icon_chrome_svg__a'>
        <path fill='#fff' d='M4.893 4.679h65.625v65.625H4.893z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconChrome;
